<template>
  <!-- TODO: 增加搜索、过滤 -->
  <!-- TODO: 网站来人主动通知客服端，增加开关，默认关闭 -->
  <!-- TODO: 支持勾选只显示在线访客，过滤掉离线访客 -->
  <!-- TODO: 统计数据：pv、uv、当前在线访客数、以及变化曲线，支持过滤查看不同日期 -->
  <div id='bd-main'>
    <el-row style="margin-top: 5px; margin-bottom: 5px;">
      <el-col :span="1"><el-button size="mini" @click="refreshData()"><i class="el-icon-refresh"></i>刷新</el-button></el-col>
      <el-radio-group v-model="status" size="mini" @change="handleTypeChange">
        <el-radio-button label="connected">当前在线</el-radio-button>
        <el-radio-button label="disconnected">已离线</el-radio-button>
        <el-radio-button label="all">全部</el-radio-button>
      </el-radio-group>
    </el-row>
    <el-table v-loading="isLoading" :data="userBrowses.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="visitor.nickname" label="访客"></el-table-column>
      <el-table-column prop="title" label="当前访问页">
        <template slot-scope="scope"><a :href="scope.row.url" target="_blank">{{ scope.row.title }}</a></template>
      </el-table-column>
      <el-table-column prop="referrer" label="来源页面">
        <template slot-scope="scope"><a :href="scope.row.referrer" target="_blank">{{ scope.row.referrer }}</a></template>
      </el-table-column>
      <el-table-column prop="location" label="来源地区"></el-table-column>
      <el-table-column prop="ip" label="IP" width="130"></el-table-column>
      <!-- <el-table-column prop="keyword" label="关键词"></el-table-column> -->
      <el-table-column prop="visitor.client" label="来源渠道" width="100"></el-table-column>
      <!-- <el-table-column prop="email" label="访问时长"></el-table-column> -->
      <el-table-column prop="sessions" label="深度" width="50">
        <template slot-scope="scope">{{ scope.row.sessions.length }}</template>
      </el-table-column>
      <el-table-column prop="visitor.connectionStatus" label="状态" width="50">
        <template slot-scope="scope">{{ scope.row.visitor.connectionStatus === 'connected' ? '在线' : '离线' }}</template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="最近活跃" width="120">
        <template slot-scope="scope">{{ scope.row.updatedAt.substring(5) }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="browseInvite(scope.$index, scope.row)" type="text" size="small" :disabled="isDisabled(scope.row)">
            邀请会话
          </el-button>
          <el-button @click="viewTrack(scope.$index, scope.row)" type="text" size="small" v-if="showAuthority.debug">
            查看轨迹
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userBrowses.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      isLoading: false,
      status: 'connected',
    }
  },
  computed: {
    ...mapGetters([ 'userBrowses', "showAuthority" ]),
  },
  methods: {
    ...mapActions([ 'queryBrowseAdmin2' ]),
    //
    isDisabled (record) {
      return record.visitor.connectionStatus !== 'connected'
    },
    handleTypeChange(value) {
      // console.log('handleTypeChange:', value)
      this.refreshData()
    },
    browseInvite(index, browse) {
      console.log('browseInvite:', index, browse)
      // TODO:
      this.$message.warning('browseInvite 即将上线，敬请期待')
    },
    viewTrack(index, browse) {
      console.log('viewTrack:', index, browse)
      // TODO:
      this.$message.warning('viewTrack 即将上线，敬请期待')
    },
    handleSuccess(response) {
      this.isLoading = false
    },
    handleError(error) {
      this.isLoading = false
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val - 1}`);
      this.isLoading = true
      let payload = { status: this.status, page: val - 1, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.queryBrowseAdmin2(payload)
    },
    refreshData() {
      this.isLoading = true
      let payload = { status: this.status, page: 0, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.queryBrowseAdmin2(payload)
    }
  },
  created() {
    this.refreshData()
  },

}
</script>

<style scoped>

</style>
